import { render } from "./FinancialTransfersTab.vue?vue&type=template&id=5a4798fa&scoped=true"
import script from "./FinancialTransfersTab.vue?vue&type=script&lang=js"
export * from "./FinancialTransfersTab.vue?vue&type=script&lang=js"

import "./FinancialTransfersTab.vue?vue&type=style&index=0&id=5a4798fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4798fa"]])

export default __exports__